<template>
  <div>
    <!-- 共用 nav -->
    <nav id="top" class="navbar navbar-expand-lg navbar-light fixed-top py-2">
      <div class="container-xl">
        <a
          class="navbar-brand brand-logo"
          href="#top"
          @click="goHome('top')"
        ><img src="@/assets/images/logo.png"></a>
        <button
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
          class="navbar-toggler navbar-toggler-right navbar-toggler-icon collapsed"
          data-bs-target="#navbarResponsive"
          data-bs-toggle="collapse"
          type="button"
        />

        <div id="navbarResponsive" class="navbar-collapse collapse">
          <ul
            class="navbar-nav ms-auto my-lg-0"
          >
            <li class="nav-item">
              <a class="nav-link mx-5 mx-xxl-4 ms-0 px-0" @click.prevent="goHome('about')">アフィリエイトプログラム</a>
            </li>
            <li class="nav-item">
              <a class="nav-link mx-5 mx-xxl-4 ms-0 px-0" @click.prevent="goHome('commission')">コミッション</a>
            </li>
            <li class="nav-item">
              <a class="nav-link mx-5 mx-xxl-4 ms-0 px-0" @click.prevent="goHome('faq')">よくある質問</a>
            </li>
            <li
              data-bs-target="#navbarResponsive"
              data-bs-toggle="collapse"
              class="nav-item"
            >
              <a class="nav-link mx-5 mx-xxl-4 ms-0 px-0" @click.prevent="goFAQ">お問い合わせ</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link mx-5 mx-xxl-4 ms-0 px-0"
                @click="goReview"
              >メディア掲載</a>
            </li>
            <li
              data-bs-target="#navbarResponsive"
              data-bs-toggle="collapse"
            >
              <a
                class="btn btn-primary ms-0 px-3 mt-3 mt-lg-0 ms-xxl-4 btn-golden"
                @click="goProxyRegister"
              >無料登録</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- nav End -->
    <p>
      <a class="gotop" href="#top">↑</a>
    </p>
    <FAQ v-if="$store.state.user.isFAQActive && !$store.state.user.isProxyRegisterActive && !$store.state.user.isConditionActive && !$store.state.user.isReviewActive" />
    <Proxy v-if="$store.state.user.isProxyRegisterActive && !$store.state.user.isFAQActive && !$store.state.user.isConditionActive && !$store.state.user.isReviewActive" />
    <Condition v-show="$store.state.user.isConditionActive && !$store.state.user.isProxyRegisterActive&& !$store.state.user.isFAQActive && !$store.state.user.isReviewActive" />
    <Review v-show="$store.state.user.isReviewActive && !$store.state.user.isProxyRegisterActive && !$store.state.user.isConditionActive && !$store.state.user.isFAQActive" />

    <div v-if="!$store.state.user.isFAQActive && !$store.state.user.isProxyRegisterActive && !$store.state.user.isConditionActive && !$store.state.user.isReviewActive">
      <header class="masthead">
        <div class="container px-4 px-lg-5">
          <div class="row gx-4 gx-lg-5 h-100 align-items-center justify-content-center text-center">
            <div class="align-self-end masthead-title">
              <h1 class="text-white p-0 h1title">
                ライブ&テーブルを<br>もっと日常へ
              </h1>

              <h2 class="text-white p-0">
                次世代のエンターテイメントを一緒に作っていきましょう
              </h2>
            </div>

            <div class="col-lg-8 align-self-baseline">
              <a class="btn btn-primary btn-xl btn-golden" @click="goProxyRegister">今すぐ登録 </a>
            </div>
          </div>
        </div>
      </header>
      <!-- header End -->

      <section id="structure" class="page-section">
        <div class="container px-4 px-lg-5 justify-content-sm-center">
          <h2 class="text-center mb-2">
            アフィリエイトの流れ
          </h2>
          <h6 class="text-dark-black text-center py-2">
            勝winのアフィリエイトの流れは簡単です。アフィリエイトリンクなどを取得し、<br>
            ご自身のサイトにアップロードするのみ。
          </h6>

          <div class="row gx-4 gx-lg-5">
            <div class="col-lg-4 col-md-6 text-center">
              <div class="mt-5">
                <div class="mb-4">
                  <img class="structure_img" src="@/assets/images/structure01.svg">
                </div>

                <h3 class="h4 mb-2 text-main">
                  1. 登録
                </h3>

                <p class="text-dark-black mb-0 pt-3">
                  まずは、登録画面にて必要事項を入力し、 勝winのメンバーになります。
                </p>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 text-center">
              <div class="mt-5">
                <div class="mb-4">
                  <img class="structure_img" src="@/assets/images/structure02.svg">
                </div>

                <h3 class="h4 mb-2 text-main">
                  2. 誘致
                </h3>

                <p class="text-dark-black mb-0 pt-3">
                  サイトやSNS、Youtubeなどで勝winのサービスなどを紹介いただき、新規メンバー様の獲得を行います。
                </p>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 text-center">
              <div class="mt-5">
                <div class="mb-4">
                  <img class="structure_img" src="@/assets/images/structure03.svg">
                </div>

                <h3 class="h4 mb-2 text-main">
                  3. コミッション獲得
                </h3>

                <p class="text-dark-black mb-0 pt-3">
                  紹介いただいた加盟メンバー様のご利用状況に 応じて、コミッションを獲得できます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- structure page-section End -->

      <section id="about" class="page-section bg-about">
        <div class="container px-4 px-lg-5">
          <div class="row gx-4 gx-lg-5 justify-content-center">
            <div class="col-lg-8 text-center">
              <h2 class="text-white mb-5 about-text">
                アフィリエイトプログラムについて
              </h2>

              <p class="text-light mb-3 about-text">
                勝winのアフィリエイトプログラムは、誰でも気軽に簡単に始めることができます。
              </p>

              <p class="text-light mb-3 about-text">
                コミッションは業界最高レベルを誇る最大55％。
              </p>

              <p class="text-light mb-3 about-text">
                ほかのオンラインカジノでは味わえない勝winの魅力を皆様に宣伝するご協力をぜひお願いいたします。
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- about page-section End -->

      <section id="commission" class="page-section">
        <div class="container px-4 px-lg-5">
          <h2 class="text-center mb-5">
            コミッションについて
          </h2>

          <p class="text-center text-muted mb-0">
            コミッションはご紹介いただいたアフィリエイトメンバーの成績によって決定されます。<br>また、各月の紹介人数に応じてコミッションのパーセンテージも変動いたしますので、より多くのアフィリエイトメンバーを誘致すると、より多くのコミッションを獲得いただけます。
          </p>

          <div class="row gx-4 gx-lg-5 justify-content-center">
            <table class="inmoney_table table">
              <tbody>
                <tr>
                  <th>毎月の新規入金者数</th>
                  <th>コミッション</th>
                </tr>
                <tr>
                  <td>0-10人</td>
                  <td>30%</td>
                </tr>
                <tr>
                  <td>11-20人</td>
                  <td>35%</td>
                </tr>
                <tr>
                  <td>21-40人</td>
                  <td>40%</td>
                </tr>
                <tr>
                  <td>41-70人</td>
                  <td>45%</td>
                </tr>
                <tr>
                  <td>71-100人</td>
                  <td>50%</td>
                </tr>
                <tr>
                  <td>101以上</td>
                  <td>55%</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p class="text-center text-muted mb-4">
            コミッションの計算公式は以下の通りです: <br>（勝負値（ベット額-ペイアウト）-
            ボーナス費用 - プラットフォーム費用 - ジャックポット - 手数料 ） &#215; コミッション％
          </p>

          <p class="text-center text-muted mb-4">
            当サイトではサブアフィリエイトプログラムもご提供しております。<br>
            既存のアフィリエイトパートナーが、新規アフィリエイトパートナーを紹介いただくと、<br>招待されたアフィリエイトパートナーの収益の5%
            がコミッションとして獲得いただけます。
          </p>
        </div>
      </section>
      <!-- commission page-section End -->

      <section id="structure" class="p-0 page-section">
        <div class="container px-4 px-lg-5">
          <div class="row gx-4 gx-lg-5">
            <div class="col-lg-6 order-lg-2">
              <div><img alt="..." class="img-fluid" src="@/assets/images/program.png"></div>
            </div>

            <div class="col-lg-6 order-lg-1">
              <div class="pt-4 pt-lg-0 p-lg-4">
                <h2 class="mb-4">
                  当プログラムのメリット
                </h2>

                <p class="text-third fs-5 fw-normal mb-0">
                  &mid; 最高55&#37; のレベニューシェア
                </p>

                <p class="ps-4 text-sec-black">
                  どなたでも簡単に高いコミッションを獲得いただけます。
                </p>

                <p class="text-third fs-5 fw-normal mb-0">
                  &mid; 管理画面のわかりやすさ
                </p>

                <p class="ps-4 text-sec-black">
                  いつでも詳細かつ最新のデータを確認いただけます。
                </p>

                <p class="text-third fs-5 fw-normal mb-0">
                  &mid; 迅速かつ安全なお支払い
                </p>

                <p class="ps-4 text-sec-black">
                  毎月複数の決済方法から選択ができ、いずれも 迅速かつ安全なお支払いを保証いたします。
                </p>

                <p class="text-third fs-5 fw-normal mb-0">
                  &mid; 親切なカスタマーサポート
                </p>

                <p class="ps-4 text-sec-black">
                  問題やご質問、ご意見などがございましたら、お気楽にカスタマーサポートまでご連絡くださいませ。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- structure page-section End -->

      <!-- faq -->
      <section id="faq" class="page-section">
        <div class="container px-4 px-lg-5">
          <h2 class="text-center mb-5">
            よくある質問
          </h2>
          <div id="accordionExample" class="accordion qa-acco">
            <div class="accordion-item">
              <h2 id="headingOne" class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  アフィリエイトプログラムに参加するには?
                </button>
              </h2>
              <div
                id="collapseOne"
                class="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  まずは、下記URLより必要事項をご記入の上、アカウントの作成をお願いいたします。<br>アカウントの作成完了後、アフィリエイトパートナ<br>
                  URL：
                  <a
                    class="links"
                    href="https://www.katsuwin.ai/affiliate"
                    target="_self"
                  >https://www.katsuwin.ai/affiliate</a>
                </div>
              </div>
            </div>
            <!-- headingOne End -->
            <div class="accordion-item">
              <h2 id="headingTwo" class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  アカウントの登録方法は?
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  下記URLより必要事項をご記入の上、アカウントの申請をお願いいたします。
                  <br>
                  ・アカウント登録URL：<a
                    class="links"
                    href="https://www.katsuwin.io/"
                    target="_self"
                  >www.katsuwin.ai</a><br>
                  アカウント登録完了後、当サイトよりメールを送付いたします。
                </div>
              </div>
            </div>
            <!-- headingTwo End -->
            <div class="accordion-item">
              <h2 id="headingThree" class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  登録にお金はかかりますか?
                </button>
              </h2>
              <div
                id="collapseThree"
                class="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  費用は一切かかりません。
                </div>
              </div>
            </div>
            <!-- headingThree End -->
            <div class="accordion-item">
              <h2 id="headingFourth" class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFourth"
                  aria-expanded="false"
                  aria-controls="collapseFourth"
                >
                  規約と注意事項はありますか?
                </button>
              </h2>
              <div
                id="collapseFourth"
                class="accordion-collapse collapse"
                aria-labelledby="headingFourth"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  こちらで規約と注意事項をご確認いただけます。<br>
                  ・リンク：<a class="links" @click="goCondition">アフィリエイト利用規約</a>
                </div>
              </div>
            </div>
            <!-- headingFourth End -->
            <div class="accordion-item">
              <h2 id="headingFifth" class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFifth"
                  aria-expanded="false"
                  aria-controls="collapseFifth"
                >
                  紹介したプレイヤーの利益はいつまでもらえますか?
                </button>
              </h2>
              <div
                id="collapseFifth"
                class="accordion-collapse collapse"
                aria-labelledby="headingFifth"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  紹介したプレイヤー様が勝winを利用する限り、パートナー様はそのプレイヤー様が生み出す利益の一部を獲得いただけます。
                </div>
              </div>
            </div>
            <!-- headingFifth End -->
            <div class="accordion-item">
              <h2 id="headingSixth" class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSixth"
                  aria-expanded="false"
                  aria-controls="collapseSixth"
                >
                  出金時にKYC書類の提出が必要ですか?
                </button>
              </h2>
              <div
                id="collapseSixth"
                class="accordion-collapse collapse"
                aria-labelledby="headingSixth"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  アフィリエイトコミッションを受領された後、そのまま出金をされる場合には、KYC書類をご提出いただく必要はございません。<br>
                  ただし、アフィリエイトコミッションを受領された後、ゲームをプレイされてから出金をされる場合には、KYC書類をご提出いただく必要がございます。
                </div>
              </div>
            </div>
            <!-- headingSixth End -->
            <div class="accordion-item">
              <h2 id="headingSeventh" class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSeventh"
                  aria-expanded="false"
                  aria-controls="collapseSeventh"
                >
                  自分のサイトにリンクを追加する方法は? ウェブサイトがないと登録できませんか?
                </button>
              </h2>
              <div
                id="collapseSeventh"
                class="accordion-collapse collapse"
                aria-labelledby="headingSeventh"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  アフィリエイトサイト内の各リンクを使用していただき、ご自身のサイトに使用いただけます。<br>
                  また、ウェブサイトをお持ちでない方でも、勝winのアフィリエイトに参加いただけます。
                </div>
              </div>
            </div>
          <!-- headingSeventh End -->
          </div>
        </div>
      </section>
    </div>

    <!-- 共用footer -->
    <footer class="text-center text-lg-start bg-light text-muted">
      <section class="pt-2 ft-frame">
        <div class="container text-center text-md-start mt-4 pb-lg-5">
          <div class="row justify-content-md-center mt-3">
            <div class="col-md-4 col-lg-3 col-xl-3 mb-4">
              <h6 class="text-uppercase fw-bold mb-4">
                <a
                  class="text-reset ft-logo"
                  target="_blank"
                  href="#"
                  @click.prevent="handleClick"
                ><img class="me-2" src="@/assets/images/logo_ft.png">
                </a>
              </h6>
            </div>

            <div class="col-md-4 col-lg-3 col-xl-3 mb-4">
              <h6 class="text-uppercase fw-bold mb-4 ft-links-title">
                AFFILIATES
              </h6>

              <p class="mb-2">
                <a class="links text-pure-black" @click="goProxyRegister">無料登録</a>
              </p>

              <p class="mb-2">
                <a
                  class="links text-pure-black"
                  @click.prevent="goHome('about')"
                >アフィリエイトプログラム</a>
              </p>

              <p class="mb-2">
                <a class="links text-pure-black" @click.prevent="goHome('commission')">コミッション</a>
              </p>

              <p class="mb-2">
                <a class="links text-pure-black" @click.prevent="goHome('faq')">よくある質問</a>
              </p>
            </div>

            <div class="col-md-4 col-lg-auto col-xl-auto mb-4">
              <h6 class="text-uppercase fw-bold mb-4 ft-links-title">
                links
              </h6>

              <p class="mb-2">
                <a class="links text-pure-black" @click="goCondition">ご利用規約</a>
              </p>

              <p class="mb-2">
                <a class="links text-pure-black" @click="goFAQ">お問い合わせ</a>
              </p>

              <p class="mb-2">
                <a class="links text-pure-black" @click="goReview">メディア掲載</a>
              </p>
            </div>
          </div>
        </div>
      </section>
      <div class="text-center p-4 copyright text-pure-black">
        Copyright © 2022 Katsuwin. All Rights Reserved.
      </div>
    </footer>
  </div>
</template>

<script>
import FAQ from './faq.vue'
import Proxy from './proxyRegister.vue'
import Condition from './conditions.vue'
import Review from './review.vue'
import './js/bootstrap.bundle.min.js'

export default {
  components: { FAQ, Proxy, Condition, Review },
  data() {
    return {
      isConditionShow: false
    }
  },
  computed: {

  },
  created() {
  },
  beforeDestroy() {
    this.$store.commit('SET_CONDITION_OPEN', false)
    this.$store.commit('SET_FAQ_OPEN', false)
    this.$store.commit('SET_PROXY_OPEN', false)
    this.$store.commit('SET_REVIEW_OPEN', false)
  },
  methods: {
    goCondition() {
      this.$store.commit('SET_CONDITION_OPEN', true)
      this.$store.commit('SET_FAQ_OPEN', false)
      this.$store.commit('SET_PROXY_OPEN', false)
      this.$store.commit('SET_REVIEW_OPEN', false)
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    },
    goFAQ() {
      this.$store.commit('SET_CONDITION_OPEN', false)
      this.$store.commit('SET_PROXY_OPEN', false)
      this.$store.commit('SET_FAQ_OPEN', true)
      this.$store.commit('SET_REVIEW_OPEN', false)
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    },
    goProxyRegister() {
      this.$store.commit('SET_CONDITION_OPEN', false)
      this.$store.commit('SET_FAQ_OPEN', false)
      this.$store.commit('SET_PROXY_OPEN', true)
      this.$store.commit('SET_REVIEW_OPEN', false)
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    },
    goHome(targetSection) {
      this.$store.commit('SET_CONDITION_OPEN', false)
      this.$store.commit('SET_FAQ_OPEN', false)
      this.$store.commit('SET_PROXY_OPEN', false)
      this.$store.commit('SET_REVIEW_OPEN', false)
      // Wait for the next tick to ensure the DOM updates
      this.$nextTick(() => {
        const targetElement = document.getElementById(targetSection)
        // If the target element exists, scroll to it
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },
    goReview() {
      this.$store.commit('SET_CONDITION_OPEN', false)
      this.$store.commit('SET_FAQ_OPEN', false)
      this.$store.commit('SET_PROXY_OPEN', false)
      this.$store.commit('SET_REVIEW_OPEN', true)
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    },
    handleClick() {
      window.open('/', '_blank')
    }
  }
}
</script>
